import * as React from 'react';

import { DEFAULT_PAGE_HEADER_HEIGHT } from 'bundles/composable-page-header/constants';
import PageHeaderHeightContext from 'bundles/composable-page-header/contexts/PageHeaderHeightContext';
import PageHeaderOffsetContext from 'bundles/composable-page-header/contexts/PageHeaderOffsetContext';

type Props = {
  children: React.ReactNode;
  // If including the meta nav, sub nav, or any banners present in SSR, add their height via this prop and it will be accounted for in page header buffer.
  // This value is only used to set the default PageHeaderHeightContext value. To change height dnynamically, use PageHeaderHeightContext "setHeight".
  additionalDefaultPageHeaderHeight?: number;
};

const GlobalPageHeaderStateProvider = ({ children, additionalDefaultPageHeaderHeight }: Props) => {
  const [shouldOffsetHeader, setShouldOffsetHeader] = React.useState(false);
  const [scrollMovementOffset, setScrollMovementOffset] = React.useState(additionalDefaultPageHeaderHeight ?? 0);
  const [height, setHeight] = React.useState(DEFAULT_PAGE_HEADER_HEIGHT + (additionalDefaultPageHeaderHeight ?? 0));

  return (
    <PageHeaderHeightContext.Provider
      value={{
        height,
        setHeight,
      }}
    >
      <PageHeaderOffsetContext.Provider
        value={{
          shouldOffsetHeader,
          setShouldOffsetHeader,
          scrollMovementOffset,
          setScrollMovementOffset,
        }}
      >
        {children}
      </PageHeaderOffsetContext.Provider>
    </PageHeaderHeightContext.Provider>
  );
};

export default GlobalPageHeaderStateProvider;
